import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import DescriptionSection from '@/components/DescriptionSection';
import ReviewsSection from '@/components/ReviewsSection';
import FAQSection from '@/components/FAQSection';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import { Badge } from '@/components/ui/badge';
import { trackViewContent, PRODUCT_DATA } from '@/lib/metaPixel';

const Offer: React.FC = () => {
  useEffect(() => {
    // Meta Pixel - ViewContent for Offer page
    trackViewContent({
      content_name: 'Special Offer - Class 10 Science Notes',
      content_category: 'Offer',
      content_ids: PRODUCT_DATA.content_ids,
      content_type: PRODUCT_DATA.content_type,
      value: PRODUCT_DATA.value,
      currency: PRODUCT_DATA.currency,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Special Offer 70% OFF - Class 10 Science Notes at ₹149 | TOPPERS BUDDY</title>
        <meta name="description" content="Limited time offer! Get class 10 science notes at 70% OFF - only ₹149 (was ₹499). Toppers short notes for CBSE board exam 2025-2026. Buy now before offer ends!" />
        <meta name="keywords" content="toppers notes offer, class 10 notes discount, science notes sale, cheap class 10 notes, best offer toppers notes" />
        <link rel="canonical" href="https://toppersbuddy.lovable.app/offer" />
        <meta property="og:title" content="Special Offer 70% OFF - Class 10 Science Notes at ₹149" />
        <meta property="og:url" content="https://toppersbuddy.lovable.app/offer" />
      </Helmet>

      <div className="flex min-h-screen flex-col bg-background">
        <Header />
        
        {/* Offer Banner */}
        <div className="bg-gradient-to-r from-red-500 to-orange-500 py-3 text-center text-white">
          <div className="container flex items-center justify-center gap-2 flex-wrap">
            <Badge className="bg-white text-red-500 hover:bg-white">LIMITED TIME</Badge>
            <span className="font-bold">🔥 70% OFF - Get Toppers Notes at just ₹149!</span>
            <Badge className="bg-yellow-400 text-black hover:bg-yellow-400">HURRY!</Badge>
          </div>
        </div>

        <main role="main" aria-label="Special Offer" className="flex-1">
          <HeroSection />
          <DescriptionSection />
          <ReviewsSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
      
      <WhatsAppButton />
    </>
  );
};

export default Offer;
